import { Component, OnInit, OnChanges, SimpleChanges, OnDestroy } from '@angular/core';
import { ISeasonWeek } from '../../../models/ISeasonWeek';
import { AdminService } from '../../../services/admin.service';
import { AlertService } from '../../../services/alert.service';
import { NflService } from '../../../services/nfl.service';
import { IOrg } from '../../../models/IOrg';
import { FormBuilder, Validators, FormGroup } from '@angular/forms'
import { AuthService } from '../../../account/auth.service';
import { IGame } from '../../../models/IGame';
import { BaseService } from '../../../services/base.service';
import { Http } from '@angular/http';
import { ISeason } from '../../../models/ISeason';
import { IWeek } from '../../../models/IWeek';
import { OrgSeasonWeekService } from '../../../services/orgseasonweek.service';
import { IOrgSeasonWeek } from '../../../models/IOrgSeasonWeek';
import { Subscription } from 'rxjs';



@Component({
  selector: 'app-games',
  templateUrl: './games.component.html',
  styleUrls: ['./games.component.scss']
})
export class GamesComponent implements OnInit, OnDestroy {

  public isRequesting: boolean = false;

  public model: IOrgSeasonWeek = { season: null, seasonType: null, week: null, org: null };
  public orgs: IOrg[];
  public selectedOrg: IOrg;
  public seasonWeeks: ISeasonWeek[] = [];
  public selectedSeason: ISeason;
  public selectedWeek: IWeek;
  public games: IGame[];
  public orgUserGames: IGame[];
  public disabled: boolean = false;
  public localTime: string;
  public serverStartDateTime: Date;
  public error: any;
  public seasons: ISeason[];
  public weeks: IWeek[];

  form: FormGroup;
  constructor(private formBuilder: FormBuilder,
    private adminService: AdminService,
    private nflService: NflService,
    private orgSeasonWeekService: OrgSeasonWeekService,
    private baseService: BaseService) {
  }

  public orgEvent: Subscription;
  public weekEvent: Subscription;
  public seasonEvent: Subscription;
  ngOnInit() {
    this.form = this.formBuilder.group({
      season: [null, [Validators.required, Validators.min(2000), Validators.max(2040)]],
      week: [null, [Validators.required, Validators.min(1), Validators.max(23)]]
    });

    //this.model.userId = this.authService.user.id;
    this.orgEvent = this.orgSeasonWeekService.org.subscribe(org => {
      this.model.org = org;
      this.weekEvent = this.orgSeasonWeekService.season.subscribe(season => {
        this.model.season = season;
        this.seasonEvent = this.orgSeasonWeekService.week.subscribe(week => {
          this.model.week = week;
          this.getGames();
        });
      });
    });

  }
  ngOnDestroy(): void {
    this.orgEvent.unsubscribe();
    this.seasonEvent.unsubscribe();
    this.weekEvent.unsubscribe();
  }

  getGames() {
    this.isRequesting = true
    this.nflService.getGames(this.model).subscribe(result => {
      this.games = result as IGame[];
      this.games.sort((a, b) => this.baseService.getEpochTime(a.startDateTime) - this.baseService.getEpochTime(b.startDateTime));
      this.isRequesting = false;
    });
  }

  create() {
    this.isRequesting = true;
    if (this.form.valid) {
      this.adminService.createNflSeasonWeek(this.model).subscribe(response => {
        console.log(response);
        this.isRequesting = false;
      })
    }
    this.isRequesting = false;

  }

  createOrgGame() {
    this.isRequesting = true;
    if (this.selectedOrg && this.form.valid) {
      this.adminService.createOrgGames(this.model, this.selectedOrg).subscribe(response => {
        this.isRequesting = false;
      })

    }
  }


  updateScores() {
    
    this.nflService.updateScores(this.model).subscribe(result => {
      this.games = result as IGame[];
      this.games.sort((a, b) => this.baseService.getEpochTime(a.startDateTime) - this.baseService.getEpochTime(b.startDateTime));
    })
  }

  updateOrgGameScores()  {
    this.nflService.updateOrgGameScores(this.model).subscribe(result => {
      this.orgUserGames = result as IGame[]
      this.orgUserGames.sort((a, b) => this.baseService.getEpochTime(a.startDateTime) - this.baseService.getEpochTime(b.startDateTime));
    })
 }

  localtime(gamestart: any) {
    return this.baseService.getLocalTimeFromUtc(gamestart);
  }

  setCurrentSeason($event: MouseEvent, season) {
    this.model.season = season.name;
    this.getGames();
    //this.getRaceResults();
    //this.getRaceSeasonResults();
    
  }

  setCurrentWeek($event: MouseEvent, week) {
    
    this.model.week = week.name;
    this.getGames();
    
  }
}






// WEBPACK FOOTER //
// /Users/vincenzodavi/source/quickpickpool_aspnetcore3/quickpickpool_aspnetcore3/client/src/app/admin/nfl/games/games.component.ts